module.exports = __webpack_public_path__ + "static/media/thanks-toptalent-logo.ea9d7cfb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/thanks-toptalent-logo.svg
// module id = 482
// module chunks = 0